// extracted by mini-css-extract-plugin
export default {"seriesToggleButton":"SeriesToggleButton_seriesToggleButton__O7f5u","selected":"SeriesToggleButton_selected__lhpJB"};